var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCafe({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons / \xD0\xA0\xD0\xB5\xD1\x81\xD1\x82\xD0\xBE\xD1\x80\xD0\xB0\xD0\xBD"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M14.0625 3.125H17.1875V18.75H14.0625V3.125Z",
    fill: "#956446"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M21.875 17.1875C21.875 18.8451 21.2165 20.4348 20.0444 21.6069C18.8723 22.779 17.2826 23.4375 15.625 23.4375C13.9674 23.4375 12.3777 22.779 11.2056 21.6069C10.0335 20.4348 9.375 18.8451 9.375 17.1875V3.125H6.25V17.1875C6.25224 19.4014 7.03789 21.543 8.46779 23.2332C9.89769 24.9233 11.8796 26.0529 14.0625 26.4219V46.875H17.1875V26.4219C19.3704 26.0529 21.3523 24.9233 22.7822 23.2332C24.2121 21.543 24.9978 19.4014 25 17.1875V3.125H21.875V17.1875Z",
    fill: "#956446"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M34.375 3.12497H32.8125V46.875H35.9375V31.25H40.625C41.4538 31.25 42.2487 30.9207 42.8347 30.3347C43.4208 29.7486 43.75 28.9538 43.75 28.125V12.5C43.7983 11.2559 43.5889 10.0152 43.1349 8.85592C42.6808 7.69663 41.992 6.64373 41.1116 5.76336C40.2312 4.88298 39.1783 4.19415 38.019 3.74011C36.8598 3.28607 35.6191 3.07664 34.375 3.12497ZM40.625 28.125H35.9375V6.3906C40.4375 7.2656 40.625 11.9218 40.625 12.5V28.125Z",
    fill: "#956446"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCafe);
export default __webpack_public_path__ + "static/media/cafe.aed6c6c28aa3f5062fc04e0489cd7e45.svg";
export { ForwardRef as ReactComponent };